import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { teamBadgeUrl } from "@/lib/api";

export default function TeamBadge({ teamCode, teamShort, size = 24, className }) {
  const [error, setError] = useState(false);
  const url = teamBadgeUrl(teamCode, size >= 50 ? 50 : 25);
  if (!url || error) {
    return (
      <span
        className={cn(
          "inline-grid place-items-center rounded-full bg-totem-surfaceHigh text-totem-textDim mono font-semibold",
          className
        )}
        style={{ width: size, height: size, fontSize: Math.max(9, size / 2.4) }}
      >
        {(teamShort || "??").slice(0, 3)}
      </span>
    );
  }
  return (
    <img
      src={url}
      alt={teamShort || "team"}
      width={size}
      height={size}
      onError={() => setError(true)}
      className={cn("inline-block object-contain", className)}
    />
  );
}
